module.exports = "/images/slick-next.svg?6eac5d23e9dde4ef2af65cccc6c4f7f3";